module.exports = __webpack_public_path__ + "static/media/title.b7ecbf04.wav";